import { useQueryClient } from '@tanstack/react-query';
import { collection, getFirestore, onSnapshot, orderBy, query, where } from 'firebase/firestore';
import { useEffect, useState } from 'react';

import { useAuth } from '@/modules/auth/hooks/useAuth';
import { firebaseApp } from '@/services/firebase';
import { MediaHistory } from '@/types';
import { FirestoreCollections } from '@/types/firestore';

const firebaseDb = getFirestore(firebaseApp);

export const useMediasInHistory = () => {
  const [isLoading, setIsLoading] = useState(true);
  const [hasError, setHasError] = useState(false);
  const [mediasInHistory, setMediasInHistory] = useState<MediaHistory[]>([]);
  const queryClient = useQueryClient();
  const { user } = useAuth();

  useEffect(() => {
    if (!user?.UUID) return;
    const queryConstraints = [
      orderBy('lastCompletionDate', 'desc'),
      where('lastCompletionDate', '>', 0),
      where('isCompleted', '==', true),
    ];

    const unsubscribe = onSnapshot(
      query(
        collection(
          firebaseDb,
          FirestoreCollections.Users,
          user.UUID,
          FirestoreCollections.PlayHistory
        ),
        ...queryConstraints
      ),
      (querySnapshot) => {
        setIsLoading(true);
        const mediaHistories: MediaHistory[] = [];

        querySnapshot.forEach((doc) => {
          const data = doc.data() as MediaHistory;
          mediaHistories.push(data);
        });

        setMediasInHistory(mediaHistories);
        setIsLoading(false);
        setHasError(false);
      },
      () => {
        setIsLoading(false);
        setHasError(true);
      }
    );

    return () => {
      unsubscribe();
    };
  }, [user?.UUID, queryClient]);

  return { mediasInHistory, hasError, isLoading };
};
